import React from 'react';
import { DataGridLayout, List, ListHeader, ListPageLayout, TableBodyWithGrouping } from 'framework/list';
import useLedgerService from 'domain/finance/ledger/useLedgerService';
import CreateJournalEntryButton from 'domain/finance/journalEntry/shared/button/CreateJournalEntryButton';
import ViewLedgerButton from 'domain/finance/ledger/shared/button/ViewLedgerButton';
import BalanceField from 'domain/finance/ledger/shared/field/BalanceField';
import LedgerAccountField from 'domain/finance/ledger/shared/field/LedgerAccountField';
import ListPageHeaderWrapper from '../../shared/ListPageHeaderWrapper';

const LedgerListPage = () => {
  const { search } = useLedgerService();

  return (
    <List getDataMethod={search}>
      <ListPageLayout
        header={<ListPageHeaderWrapper header={<ListHeader label="Ledger" />} />}
        actions={[<CreateJournalEntryButton />]}
      >
        <DataGridLayout
          sxTableWrapper={{
            '& table.MuiTable-root': {
              minWidth: '980px',
            },
          }}
          isSmallTable
          buttons={[<ViewLedgerButton source="id" isVisible={(data: any) => !data.children?.length} />]}
          tableBodyComponent={(props: any) => (
            <TableBodyWithGrouping {...props} childrenSource="children" toggleSource="name" />
          )}
        >
          <LedgerAccountField source="name" label="Name" width="60%" />
          <BalanceField source="balance" nameSource="name" label="Balance" width="35%" />
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default LedgerListPage;
